import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

const GrzField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = 'grid-item one-whole',
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='grz'
        propertyName='grz'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.grzField', 'GRZ')}</span>}
        value={insertionData.grz}
        maxLength={4}
        type='text'
        errors={validationMessages!.grz ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default GrzField
